enum EStrapiRichText {
	quote = 'quote',
	paragraph = 'paragraph',
	warning = 'warning',
	table = 'table',
	delimiter = 'delimiter',
	list = 'list',
	latex = 'latex',
	image = 'image',
	code = 'code',
	header = 'header',
	ordered = 'ordered',
	unordered = 'unordered',
	internalLink = 'internalLink',
	paragraphWithLinks = 'paragraphWithInternalLinks'
}

enum EUserJourney {
	prelude = 'prelude',
	parts = 'parts',
	hints = 'hints',
	postlude = 'postlude',
	unset = 'unset'
}

export { EStrapiRichText, EUserJourney };
